// extracted by mini-css-extract-plugin
export default {"wrapper":"ManualMeterReadingImport_wrapper__27WsG","headerActions":"ManualMeterReadingImport_headerActions__OZzvX"};